var path = '/LinearResourceForm/'

function get (http, id) {
    return http.get(path + `Get`)
}
function put (http, assemblageDto) {
    return http.put(path, assemblageDto)
}
function search (http, searchDto) {
    return http.post(path + 'Search', searchDto)
}
export default {
    get: get,
    put: put,
    search: search
}



// WEBPACK FOOTER //
// ./src/services/siteForm/LinearResourceService.js